<template>
  <basic-container>
    <div>
      <el-form ref="searchForm" :model="search" label-width="100px" margin-top="0">
        <el-row>
          <el-col span="6">
            <el-form-item label="小区" prop="areaName">
              <el-select
                v-model="search.areaName"
                filterable
                @change="getTreeNode(3, search.areaName)"
                style="width: 100%;"
                placeholder="请选择小区"
              >
                <el-option
                  v-for="item in allPropertyList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="楼栋" prop="building">
              <el-select
                v-model="search.building"
                filterable
                @change="getTreeNode(4, search.building)"
                placeholder="请选择楼栋"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in buildingList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="单元" prop="unitName">
              <el-select
                v-model="search.unitName"
                filterable
                @change="getTreeNode(6, search.unitName)"
                placeholder="请选择单元"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in unitList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="房间" prop="roomId">
              <el-select
                v-model="search.roomId"
                filterable
                placeholder="请选择房间"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in roomList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item>
            <el-button type="primary" @click="submitSearchForm" icon="el-icon-search"
              >搜索</el-button
            >
            <el-button type="white" @click="searchReset" icon="el-icon-delete">清空</el-button>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col span="6">
            <el-form-item label="业主">
              <el-input disabled="true" v-model="userInfo.householder"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="电话">
              <el-input disabled="true" v-model="userInfo.householderPhone"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="生日">
              <el-input disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="证件" v-model="userInfo.idCard">
              <el-input disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="6">
            <el-form-item label="房产">
              <el-input disabled="true" v-model="userInfo.roomName"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="户号">
              <el-input disabled="true" v-model="userInfo.shortCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="房号">
              <el-input disabled="true" v-model="userInfo.shortCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="面积">
              <el-input disabled="true" v-model="userInfo.floorage"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="费用信息" name="first">
          <avue-crud
            :option="option1"
            :table-loading="loading1"
            :data="data1"
            :page.sync="page1"
            ref="crud1"
            @search-change="searchChange1"
            @search-reset="searchReset"
            @selection-change="selectionChange1"
            @current-change="currentChange1"
            @size-change="sizeChange1"
          >
          </avue-crud>
        </el-tab-pane>

        <el-tab-pane label="报修信息" name="second">
          <avue-crud
            :option="option2"
            :table-loading="loading2"
            :data="data2"
            :page.sync="page2"
            ref="crud2"
            @search-change="searchChange2"
            @search-reset="searchReset"
            @selection-change="selectionChange2"
            @current-change="currentChange2"
            @size-change="sizeChange2"
          >
            <template slot="isExigency" slot-scope="scope">
              <el-tag v-show="scope.row.isExigency == 1">紧急</el-tag>
              <el-tag type="danger" v-show="scope.row.isExigency == 2">特急</el-tag>
              <el-tag type="info" v-show="scope.row.isExigency == 0">一般</el-tag>
            </template>
            <template slot="complaintParentStatus" slot-scope="scope">
              <el-tag type="danger" v-show="scope.row.complaintParentStatus == 1">登记</el-tag>
              <el-tag type="danger" v-show="scope.row.complaintParentStatus == 2">受理</el-tag>
              <el-tag type="success" v-show="scope.row.complaintParentStatus == 3">处理</el-tag>
              <el-tag type="success" v-show="scope.row.complaintParentStatus == 4">核验</el-tag>
              <el-tag type="warning" v-show="scope.row.complaintParentStatus == 5">完成</el-tag>
            </template>
            <template slot="complaintSubStatus" slot-scope="scope">
              <el-tag>{{ showResult(scope.row) }}</el-tag>
            </template>
          </avue-crud>
        </el-tab-pane>

        <el-tab-pane label="车辆信息" name="third">
          <avue-crud
            :option="option3"
            :table-loading="loading3"
            :data="data3"
            :page.sync="page3"
            ref="crud3"
            @search-change="searchChange3"
            @search-reset="searchReset"
            @selection-change="selectionChange3"
            @current-change="currentChange3"
            @size-change="sizeChange3"
          >
          </avue-crud>
        </el-tab-pane>
      </el-tabs>
    </div>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { getPage } from '@/api/v4ward/paybilllist/feepaybilllist';
import { getOptionNode, getTreeChildrenPowerNode } from '@/api/v4ward/property/baseproperty';
import { getList, listCarMonthByProperty } from '@/api/v4ward/car/carmonth';
import { loadZhxx } from '@/api/charge';
import { listByProperty } from '@/api/v4ward/repair/repairinfo';

export default {
  data() {
    return {
      search: {
        areaName: '',
        building: '',
        unitName: '',
        roomId: '',
      },
      allPropertyList: [],
      buildingList: [],
      unitList: [],
      roomList: [],
      form: {},
      loading1: false,
      page1: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },

      loading2: false,
      page2: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },

      loading3: false,
      page3: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      activeName: 'first',
      option1: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        excelBtn: false,
        selection: false,
        addBtn: false,
        menu: false,
        menuPosition: 'center',
        align: 'center',
        column: [
          {
            label: '房产',
            prop: 'roomName',
          },
          {
            label: '户主',
            prop: 'householdName',
          },
          // {
          //   label: '户主电话',
          //   prop: 'linkPhone',
          // },
          {
            label: '收费周期',
            prop: 'billcycleNo',
          },
          {
            label: '开始时间',
            prop: 'billStartDate',
            type: 'date',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '结束时间',
            prop: 'billEndDate',
            type: 'date',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '理论金额',
            prop: 'calAmount',
          },
          {
            label: '减免金额',
            prop: 'derateAmount',
          },
          {
            label: '抵扣金额',
            prop: 'accountpayAmount',
          },
          {
            label: '优惠金额',
            prop: 'couponAmount',
          },
          {
            label: '应收金额',
            prop: 'shouldAmount',
          },
          {
            label: '收费金额',
            prop: 'payAmount',
          },
          {
            label: '费用种类',
            prop: 'feeSort',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=fee_sort',
            dataType: 'number',
          },
          {
            label: '是否付款',
            prop: 'payFlag',
            type: 'select',
            props: {
              label: 'label',
              value: 'value',
            },
            dicData: [
              {
                label: '是',
                value: 1,
              },
              {
                label: '否',
                value: 0,
              },
            ],
            dataType: 'number',
          },
          {
            label: '收费人',
            prop: 'cashierName',
          },
          {
            label: '支付方式',
            prop: 'payType',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
            dataType: 'number',
          },
          {
            label: '收费时间',
            prop: 'payTime',
            type: 'date',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
        ],
      },
      option2: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        excelBtn: false,
        selection: false,
        addBtn: false,
        menu: false,
        menuPosition: 'center',
        align: 'center',
        column: [
          {
            label: '登记时间',
            prop: 'createTime',
            type: 'datetime',
          },
          {
            label: '反馈内容',
            prop: 'repairDesc',
            type: 'input',
            overHidden: true,
          },
          {
            label: '回访地区',
            prop: 'roomName',
            type: 'input',
          },
          {
            label: '发生地区',
            prop: 'address',
            type: 'input',
            overHidden: true,
          },
          {
            label: '紧急程度',
            prop: 'isExigency',
            slot: true,
          },
          {
            label: '工单编号',
            prop: 'wordId',
          },
          {
            label: '工单状态',
            prop: 'complaintSubStatus',
            slot: true,
          },
          {
            label: '当前环节',
            prop: 'complaintParentStatus',
            slot: true,
          },
          {
            label: '经办部门',
            prop: 'operatorDept',
            props: {
              label: 'title',
              value: 'value',
            },
            dicUrl: '/api/repair/selectDept',
            type: 'select',
          },
          {
            label: '最后办理时间',
            prop: 'updateTime',
            type: 'datetime',
          },
        ],
      },
      option3: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        excelBtn: false,
        selection: false,
        addBtn: false,
        menu: false,
        menuPosition: 'center',
        align: 'center',
        column: [
          {
            label: '车场名称',
            prop: 'spaceId',
            props: {
              label: 'title',
              value: 'key',
            },
            dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
          },
          {
            label: '车牌号',
            prop: 'carNo',
          },
          {
            label: '车辆分类',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_class',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            prop: 'carClass',
          },
          {
            label: '车辆类型',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            prop: 'carType',
          },
          {
            label: '收费套餐',
            prop: 'ruleName',
          },
          {
            label: '应收金额',
            prop: 'shouldMoney',
          },
          {
            label: '支付金额',
            prop: 'payMoney',
          },
          {
            label: '客户姓名',
            prop: 'customerName',
          },
          {
            label: '客户手机',
            prop: 'customerPhone',
          },
          {
            label: '状态',
            prop: 'status',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_month_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
          },
          {
            label: '支付方式',
            prop: 'payType',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
          },
          {
            label: '支付时间',
            prop: 'payTime',
            type: 'date',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '租赁起期',
            prop: 'buyStartTime',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
          },
          {
            label: '租赁止期',
            prop: 'buyEndTime',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 23:59:59',
          },
        ],
      },
      data1: [],
      data2: [],
      data3: [],
      userInfo: {},
    };
  },
  computed: {
    ...mapGetters(['permission']),
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.initPropertyList();
  },
  methods: {
    initPropertyList() {
      getOptionNode({}).then((data) => {
        this.allPropertyList = data.data;
      });
    },
    getTreeNode(type, id) {
      getTreeChildrenPowerNode({
        object_type: type,
        id: id,
      }).then((res) => {
        if (type == 3) {
          //楼栋下拉数据
          this.buildingList = res.data;
          this.unitList = [];
          this.roomList = [];
          this.search.building = '';
          this.search.unitName = '';
          this.search.roomId = '';
        } else if (type == 4) {
          //单元下拉数据
          this.unitList = res.data;
          this.search.unitName = '';
          this.search.roomId = '';
          this.roomList = [];
        } else if (type == 6) {
          //房间下拉数据
          this.search.roomId = '';
          this.roomList = res.data;
        } else {
          this.search.building = '';
          this.search.unitName = '';
          this.search.roomId = '';
        }
      });
    },
    showResult(row) {
      if (row.complaintParentStatus == 1) {
        return '登记中';
      } else if (row.complaintParentStatus == 2) {
        return '受理中';
      } else if (row.complaintParentStatus == 3) {
        if (row.processResult == 2) {
          return '处理完成';
        }
        return '处理中';
      } else if (row.complaintParentStatus == 4) {
        if (row.visitResult) {
          return '核验完成';
        }
        return '核验中';
      } else if (row.complaintParentStatus == 5) {
        return '已完成';
      }
    },
    handleClick(tab, event) {
      if (this.search.roomId) {
        if (tab.name === 'first') {
          this.onLoad1();
        }
        if (tab.name === 'second') {
          this.onLoad2();
        }
        if (tab.name === 'third') {
          this.onLoad3();
        }
      }
    },
    searchReset() {
      this.search = {
        areaName: '',
        building: '',
        unitName: '',
        roomId: '',
      };
      this.propertyName = '';
      this.data1 = [];
      this.data2 = [];
      this.data3 = [];
      this.userInfo = {};
    },
    submitSearchForm() {
      if (!this.search.roomId) {
        this.$message.warning('请选择至房间');
        return;
      }

      loadZhxx({ roomId: this.search.roomId }).then(({ data }) => {
        this.userInfo = data[0];
      });

      if (this.activeName === 'first') {
        this.onLoad1();
      }
      if (this.activeName === 'second') {
        this.onLoad2();
      }
      if (this.activeName === 'third') {
        this.onLoad3();
      }
    },
    searchChange1(params, done) {
      this.search = params;
      this.page1.currentPage = 1;
      this.onLoad1();
    },
    selectionChange1(list) {
      this.selectionList = list;
    },
    selectionClear1() {
      this.selectionList = [];
      this.$refs.crud1.toggleSelection();
    },
    currentChange1(currentPage) {
      this.page1.currentPage = currentPage;
    },

    searchChange2(params, done) {
      this.search = params;
      this.page.currentPage = 1;
      this.onLoad2();
    },
    selectionChange2(list) {
      this.selectionList = list;
    },
    selectionClear2() {
      this.selectionList = [];
      this.$refs.crud2.toggleSelection();
    },
    currentChange2(currentPage) {
      this.page2.currentPage = currentPage;
    },
    sizeChange2(pageSize) {
      this.page2.pageSize = pageSize;
    },

    searchChange3(params, done) {
      this.search = params;
      this.page3.currentPage = 1;
      this.onLoad1();
    },
    selectionChange3(list) {
      this.selectionList = list;
    },
    selectionClear3() {
      this.selectionList = [];
      this.$refs.crud3.toggleSelection();
    },
    currentChange3(currentPage) {
      this.page3.currentPage = currentPage;
    },
    onLoad1(page) {
      page = page || this.page1;
      this.loading1 = true;
      this.search.propertyId = this.search.roomId;
      getPage(Object.assign({ current: page.currentPage, size: page.pageSize }, this.search)).then(
        ({ data }) => {
          this.page1.total = data.ipage.total ? data.ipage.total : 0;
          this.data1 = data.ipage.records;
          this.loading1 = false;
          this.selectionClear1();
        }
      );
    },
    onLoad2(page) {
      page = page || this.page2;
      this.loading2 = true;
      listByProperty(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.search)
      ).then(({ data }) => {
        this.page2.total = data.total;
        this.data2 = data.records;
        this.loading2 = false;
        this.selectionClear2();
      });
    },
    onLoad3(page) {
      page = page || this.page3;
      this.loading3 = true;
      listCarMonthByProperty(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.search)
      ).then(({ data }) => {
        this.page3.total = data.total;
        this.data3 = data.records;
        this.loading3 = false;
        this.selectionClear3();
      });
    },
  },
};
</script>

<style scoped></style>
